<template>
    <TableView/>
</template>
<style>
    /*
    @media screen and (orientation: portrait) {
        html {
            transform: rotate(-90deg);
            transform-origin: left top;
            width: 100vh;
            height: 100vw;
            overflow-x: hidden;
            position: absolute;
            top: 100%;
            left: 0;
        }
    }*/
</style>
<script>
    import TableView from './TableView.vue'

    export default {
        name: 'virtual-poker',
        components: {
            TableView
        }
    }
</script>

<style>
    /*body, html {
        margin: 0 auto;
        height: 100%;
        width: 100%;
    }
    div.wrap {
        height:100%; overflow:hidden;
    }*/
</style>
